import { Injectable, isDevMode } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
export interface ICallParams {
    tipo?: 'json';
    class?: string;
    accion: string;
    [property: string]: any;
}

export {Observable};

@Injectable({
  providedIn: 'root'
})
export class RemoteCallCommonService {
  // private _url_base = 'https://home.petrasoft.es/dev/Inscripciones/server/php/ajax/ajax.php';

  private _url_base = environment.server_url; // '//www.semanamundial.com/inscripciones/server/php/ajax/ajax.php';

  // ===========================================================================
  // ---------------------------------------------------------------------------
  constructor(
      private http: HttpClient,
  ) {
    console.log('Usando como server: ' + this._url_base);

  }

  // ===========================================================================
  // ---------------------------------------------------------------------------
  // Send post data as form data
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSOn with data to send
  public sendPost(data: ICallParams): Observable<any> {
    const url = this._url_base;
    const formData: any = new FormData();

    for (var field in data) {
        formData.append(field, data[field]);
    }

    const sub = this.http.post(url, formData);
    // sub.subscribe(
    //         (response: any) => {
    //             // sub.unsubscribe();
    //             return response
    //         },
    //         (error:HttpErrorResponse) => {
    //             console.log('RemoteCallCommonService', error);
    //             // return error;
    //         }
    //     );
    return sub;
  }

  // ===========================================================================
  // ---------------------------------------------------------------------------
  // Send post data as JSON
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSOn with data to send
  //
  //  TODO: Test if work
  public sendJSONPost(data:ICallParams): Observable<any> {
    const headers = { 'content-type': 'application/json'};
    const url = this._url_base;
    const body = JSON.stringify(Object.assign({
        tipo: 'json',
    }, data));

    return this.http.post(url, body,{'headers':headers});

  }

  // ---------------------------------------------------------------------------
  // send data to tpv
  public send2TPV(url_tpv: string, data: any): Observable<any> {
    const url = url_tpv;
    const formData: any = new FormData();

    for (var field in data) {
        formData.append(field, data[field]);
    }

    return this.http.post(url, formData);

  }

}
